<template>
  <div class="mt-10">
    <div
      class="fixed lg:right-8 md:right-8 right-4 lg:bottom-8 md:bottom-8 bottom-4 z-50"
    >
      <div
        class="flex cust-bg-229d04 items-center lg:px-6 md:px-4 px-4 lg:py-4 md:py-4 py-3 rounded-full enquiry cursor-pointer"
        pill
      >
        <a href="https://api.whatsapp.com/send?phone=917888488891">
          <div class="flex items-center">
            <img
              src="@/assets/images/about/Vector (4).png"
              class="mr-2 color-white lg:w-7 md:w-7 w-5"
              alt="whatsapp logo"
            />
            <p class="text-white fsize14 sm-fsize12 font-semibold">
              Chat With Us
            </p>
          </div>
        </a>
      </div>
    </div>
    <h2
      id="0091803486"
      class="fsize24 sm-fsize20 font-semibold hoverText1 text-232323 lg:mb-2 md:mb-2 mb-2"
    >
      {{ pageData ? pageData["0091803486"] : "What is FR?" }}
    </h2>
    <div
      class="lg:w-1/2 md:w-1/2 w-full lg:mt-0 md:mt-0 border-2 mt-4 lg:mb-0 md:mb-0 mb-8 web-hidden"
    >
      <img
        src="@/assets/images/about/Aluminium Composite Panel.png"
        alt="acp icon"
        class="h-500 sm-h-250px object-contain w-full"
      />
    </div>
    <div class="lg:flex md:flex lg:gap-20 md:gap-20 cust-flex-col-reverse">
      <div class="lg:w-1/2 md:w-1/2 w-full flex flex-col lg:mb-0 md:mb-0 mb-4">
        <p
          id="8556522340"
          class="hoverText1 fsize18 col-3535 sm-fsize14 lg:mb-4 md:mb-4 mb-4"
          v-html="
            pageData
              ? pageData['8556522340']
              : 'Fire safety is a great concern in India. The need of the hour is to use building materials that are designed to fight the fire and avert major casualties. Know a few reasons that make Eurobond FR Retardant ACPs, the ideal choice for interior and exterior applications. FR grade ACP sheets are produced from new technology-equipped manufacturing ACP lines that are now being installed by Indian ACP manufacturers. It is widely known that 80% of deaths in a fire accident are caused by smoke after a fire. Eurobond Fire Retardant ACP is the next emerging need in the Indian market because new regulation’s regarding housing and building construction have strict norms for fire safety materials uses. Fire-retardant (FR) materials have become an important ingredient in modern construction. With more and more skyscrapers towering toward the skies in bustling cities, fire proof materials are opening new avenues for the Aluminium composite panel segment.'
          "
        ></p>
        <!-- <p
          class="text-justify fsize18 col-3535 sm-fsize14 lg:mb-4 md:mb-4 mb-4"
        >
          FR grade ACP sheets are produced from new technology-equipped
          manufacturing ACP lines that are now being installed by Indian ACP
          manufacturers. It is widely known that 80% of deaths in a fire
          accident are caused by smoke after a fire. Eurobond Fire Retardant ACP
          is the next emerging need in the Indian market because new
          regulation’s regarding housing and building construction have strict
          norms for fire safety materials uses. Fire-retardant (FR) materials
          have become an important ingredient in modern construction. With more
          and more skyscrapers towering toward the skies in bustling cities,
          fire proof materials are opening new avenues for the Aluminium
          composite panel segment.
        </p> -->

        <vs-button
          id="9034329365"
          color="primary"
          class="lg:w-2/5 md:w-2/5 w-full lg:mt-2 md:mt-2 mt-1 hoverText1 lg:px-8 md:px-8 px-3 sm-fsize14"
          @click="handleClick('download-catalogues')"
        >
          {{ pageData ? pageData["9034329365"] : "Explore Catalogue" }}
        </vs-button>
      </div>
      <div
        id="0511846836"
        class="lg:w-1/2 md:w-1/2 w-full hoverText1 lg:mt-0 md:mt-0 border-2 mt-4 lg:mb-0 md:mb-0 mb-8 md:block mob-hidden"
      >
        <img
          :src="getImage(pageData['0511846836'])"
          alt="acp icon"
          class="h-500 sm-h-250px object-contain w-full"
        />
      </div>
    </div>
    <div class="lg:mt-20 md:mt-20 mt-8">
      <h3
        id="0238003174"
        class="fsize24 sm-fsize20 hoverText1 text-232323 text-center uppercase font-semibold"
      >
        {{ pageData ? pageData["0238003174"] : "Why choose FR?" }}
      </h3>
      <div
        class="lg:grid lg:grid-cols-3 md:grid md:grid-cols-2 grid grid-cols-1 gap-4"
      >
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Group 10170.png" -->
              <div class="hoverText1" id="3432935006">
                <img
                  :src="getImage(pageData['3432935006'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="0515000894"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["0515000894"] : "Non-combustible" }}
              </h2>
            </div>

            <p
              id="3648671769"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["3648671769"]
                  : " While the pure aluminium core in Eurocore & Honeycomb core in Eurocomb leaves no room for combustion, the mineral core composition of A2 and FR Plus ACPs with self-extinguishing  properties make way for protection in event of a fire."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/download (15) 1.png" -->
              <div class="hoverText1" id="1555145192">
                <img
                  :src="getImage(pageData['1555145192'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="7991032310"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["7991032310"] : "Low toxic smoke" }}
              </h2>
            </div>

            <p
              id="0829449485"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["0829449485"]
                  : "On contact with fire, the Mineral Core of A2 and FR Plus ACPs release a small dose of water, thereby emitting non-toxic smoke and harmless water vapour. Eurocore & Eurocomb being non-combustible, emits no toxic fumes, making them ideal for high-rise constructions."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/download (15) 1.png" -->
              <div class="hoverText1" id="4965948608">
                <img
                  :src="getImage(pageData['4965948608'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="3664446344"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["3664446344"] : "Superior strength" }}
              </h2>
            </div>

            <p
              id="7177378447"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["7177378447"]
                  : "In case of fire accidents, smoke & fire prove to be a major hindrance, making evacuations difficult. Eurobond Fire proof Panels prevent the spread and intensity of the fire, facilitating safer evacuations. Moreover, it doesn't let the facade fall apart, causing no or less damage to property."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Vector.png" -->
              <div class="hoverText1" id="2902015120">
                <img
                  :src="getImage(pageData['2902015120'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="9330788738"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["9330788738"] : "Industry Experts" }}
              </h2>
            </div>

            <p
              id="9291401546"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["9291401546"]
                  : "The strength of Eurobond FR ACP lies in the architectural 3003/5005 alloy, which offers high impact and scratch resistance, making them favourable for a variety of applications, especially during high-rise constructions. Low toxic smoke"
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Vector (1).png" -->
              <div class="hoverText1" id="3272252480">
                <img
                  :src="getImage(pageData['3272252480'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="4587377484"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["4587377484"] : "Everlasting Finish" }}
              </h2>
            </div>

            <p
              id="3354174384"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["3354174384"]
                  : "The secret behind the everlasting beauty of Eurobond FR ACPs is out. The PVDF/FEVE coating adds a great finish to the top skin of the panel, making it vibrant and colourful. It is also responsible for making them UV resistant, protecting them from fading, and  ensuring excellent gloss retention."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Vector (2).png" -->
              <div class="hoverText1" id="1601530811">
                <img
                  :src="getImage(pageData['1601530811'])"
                  class="w-15 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="2680488599"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["2680488599"] : "Tested and Certified" }}
              </h2>
            </div>

            <p
              id="1507376450"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["1507376450"]
                  : "Tried & tested by reputed laboratories like Exova, Thomas Bell wright, ARAI, CPRI, and Shriram, Eurobond FR ACPs are designed to rise above expectations. Eurobond FR Plus has been certified by Exova for EN 13501 standards, adhering to the B s1 d0 rating while Eurocore confirms as per EN 13501-1 as Class A2 - s1 d0"
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Vector (3).png" -->
              <div class="hoverText1" id="7088401338">
                <img
                  :src="getImage(pageData['7088401338'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="6768178063"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["6768178063"] : "3 hours fire rating" }}
              </h2>
            </div>

            <p
              id="6906191124"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["6906191124"]
                  : "Eurobond FR Plus has a 3 hour Fire rating, as per ASTM E 119 Fire test and Standard Hose Stream Test of Building Construction and Materials. This has been tested at the reputed Thomas Bell Wright Laboratory in Dubai."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/Vector (4).png" -->
              <div class="hoverText1" id="6272359278">
                <img
                  :src="getImage(pageData['6272359278'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="8654999888"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["8654999888"] : "Warranty" }}
              </h2>
            </div>

            <p
              id="2448583928"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["2448583928"]
                  : "We provide 7 to 15 years warranty, thus adding to your trust and confidence in our brand."
              }}
            </p>
          </div>
        </card>
        <card
          class="shadowonHover shadow-lg bg-white text-dark mt-4"
         
        >
          <div class="lg:p-4 md:p-4 p-4">
            <div class="">
              <!-- src="@/assets/images/download (21) 1.png" -->
              <div class="hoverText1" id="8080943723">
                <img
                  :src="getImage(pageData['8080943723'])"
                  class="w-14 h-14 m-auto mb-2 object-contain"
                  alt="service-Icon"
                />
              </div>
              <h2
                id="3934161741"
                class="text-black hoverText1 font-bold text-center fsize18 sm-fsize16 ml-4"
              >
                {{ pageData ? pageData["3934161741"] : "Innovative care" }}
              </h2>
            </div>

            <p
              id="2600804431"
              class="fsize16 hoverText1 col-3535 line-h26px font-normal lg:mt-6 md:mt-6 mt-2 sm-fsize14"
            >
              {{
                pageData
                  ? pageData["2600804431"]
                  : "What empowers A2 and FR Plus ACPs with self-extinguishing properties is the core that consists of minerals (Aluminium Trihydroxide & Magnesium Dihydroxide), Eurocore with Pure Aluminium Core, and Eurocomb with Honeycomb Core. No wonder, they turn water into vapour, leading to the release of non-toxic smoke, in contact with fire....."
              }}
            </p>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShowCMS: false,
      pageData: {},
      selectedId: "",
      direction: "rtl",
    };
  },
  watch: {
    isShowCMS(newValue) {
      console.log(newValue);
    },
    pages(value) {
      this.pageData = value["FR ACP"];
    },
  },
  computed: {
    ...mapState("cms", ["pages", "user"]),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    getImage(image) {
      if (image && image.includes("data:image/")) {
        return image;
      } else {
        if (image) {
          return `${process.env.VUE_APP_STORAGE_URL}${image}`;
        } else {
          return "https://nimbuscluster.blob.core.windows.net/server01/default/images/default2.jpg";
        }
      }
    },
    async removeClass() {
      let classData = document.getElementsByClassName("hoverText1");

      const elementsArray = Array.from(classData);

      elementsArray.forEach((element) => {
        element.classList.remove("hoverText1");
      });
    },
    addClass() {
      let classData2 = document.getElementsByClassName("hoverText1");

      let classData = document.getElementsByClassName("hoverText1");
      console.log(classData, "home");
      for (let i = 0; i < classData.length; i++) {
        classData[i].classList.add("hoverText1");
        if (classData[i]) {
          console.log(classData[i].id, "ids");
          classData[i].addEventListener("click", () => {
            this.selectedId = classData[i].id;
            console.log(this.selectedId, "selected");
            this.isShowCMS = true;
          });
        }
      }
    },
    async closePopup2() {
      console.log("close");
      this.isShowCMS = false;
      let cms = { projectName: process.env.VUE_APP_COMMUNITY_NAME };
      await this.$store.dispatch("cms/getClientCms", cms);
    },
    init() {
      let popVal = localStorage.getItem("pop");
      let val = Boolean(popVal);
      if (!val) {
        localStorage.setItem("pop", false);
      } else {
        localStorage.setItem("pop", true);
        let pop = localStorage.getItem("pop");
        this.AdPopup = Boolean(pop);
      }
    },
    async closeModal() {
      localStorage.setItem("pop", false);
      this.AdPopup = false;
    },
  },
  async mounted() {
    this.init();
    if (this.pages) {
      this.pageData = this.pages["FR ACP"];
    }

    // if (this.$route.query.token === "123") {
    //   console.log("CMS Active");
    //   await this.addClass();
    // } else {
    //   await this.removeClass();
    // }
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h-250px {
    height: 250px;
  }
}
</style>
